import { QUESTIONNAIRE_VERIFICATION_CONFIG } from "@/modules/external-verification/config";
import { ExternalVerificationRedirectPage } from "@/modules/external-verification/pages/redirect-page";
import { ExternalVerificationReturnPage } from "@/modules/external-verification/pages/return-page";
import { type CheckoutSession } from "@/types";

interface QuestionnairePageProps {
  onCheckoutFetched: (session: CheckoutSession) => void;
}

export function QuestionnaireRedirectPage(
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  _props: QuestionnairePageProps,
) {
  return (
    <ExternalVerificationRedirectPage config={QUESTIONNAIRE_VERIFICATION_CONFIG} />
  );
}

export function QuestionnaireReturnPage({
  onCheckoutFetched,
}: QuestionnairePageProps) {
  return (
    <ExternalVerificationReturnPage
      config={QUESTIONNAIRE_VERIFICATION_CONFIG}
      onCheckoutFetched={onCheckoutFetched}
    />
  );
}
